import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UserService } from "./user.service";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class AcuerdosRestService {
  apiurl = "http://localhost/api/acuerdos";

  getAllFamiliasUrl = this.apiurl + "/getAllFamilies.php";
  getAllLocationsUrl = this.apiurl + "/getAllLocations.php";
  getFamiliesFromLocationsUrl = this.apiurl + "/getFamiliesFromLocations.php";
  getArticlesFromFamiliesUrl = this.apiurl + "/getArticlesFromFamilies.php";
  getBuysSearchUrl = this.apiurl + "/getBuysSearch.php";

  constructor(public http: HttpClient, public user: UserService) {}

  getAllFamilies() {
    return this.http
      .get(this.getAllFamiliasUrl)
      .pipe(map((response) => response["data"]));
  }

  getAllLocations() {
    return this.http
      .get(this.getAllLocationsUrl)
      .pipe(map((response) => response["data"]));
  }

  getFamiliesFromLocation(locationsArray) {
    let params = new HttpParams().set("locationsArray", locationsArray);
    return this.http
      .get(this.getFamiliesFromLocationsUrl, { params: params })
      .pipe(map((response) => response["data"]));
  }

  getArticlesFromFamilies(familiesArray) {
    let params = new HttpParams().set("articlesArray", familiesArray);
    return this.http
      .get(this.getArticlesFromFamiliesUrl, { params: params })
      .pipe(map((response) => response["data"]));
  }

  getBuysSearch(searchQueryData) {   
    let params = new HttpParams()
    .set("fromDate", searchQueryData.fromDate)
    .set("untilDate", searchQueryData.untilDate)
    .set("articlesArray", searchQueryData.articlesArray);

    return this.http.get(this.getBuysSearchUrl, { params: params})     
    .pipe(map((response) => response["data"]));  
  }
}
